import { useQuery } from '@tanstack/react-query'
import Service from 'Service'
import useStores from 'hooks/useStores'
import { providersQueryKey } from './queryKeys'

export { providersQueryKey } from './queryKeys'

export function useProvidersQuery(initial = 0, take = 100) {
  const { companyStore } = useStores()
  const companyKey = companyStore.selectedCompany?.Keycompany

  return useQuery({
    queryKey: providersQueryKey(companyKey, initial, take),
    queryFn: async () => {
      const data = await Service.Providers.getAll(initial, take)
      return Array.isArray(data) ? data : []
    },
    enabled: Boolean(companyKey)
  })
}
